import type { useAuth } from '@/composables/models/useAuth';
import type { useFirebaseStorage } from '@/composables/models/useFirebaseStorage';
import type { useConfirm } from '@/composables/ui/useConfirm';
import type { useToast } from '@/composables/ui/useToast';
import type { useMockFirebaseStorage } from '@/composables/utils/useMockFirebaseStorage';
import type { useMockedRoute } from '@/composables/utils/useMockRoute';
import type { useMockedRouter } from '@/composables/utils/useMockRouter';
import type { useMockedRuntimeConfig } from '@/composables/utils/useMockRuntimeConfig';

export type UseToast = typeof useToast;
export const useToastKey = Symbol() as InjectionKey<UseToast>;

export type UseConfirm = typeof useConfirm;
export const useConfirmKey = Symbol() as InjectionKey<UseConfirm>;

export type UseRuntimeConfig = typeof useRuntimeConfig;
export type UseMockedRuntimeConfig = typeof useMockedRuntimeConfig;
export const useRuntimeConfigKey = Symbol() as InjectionKey<UseRuntimeConfig | UseMockedRuntimeConfig>;

export type UseRouter = typeof useRouter;
export type UseMockedRouter = typeof useMockedRouter;
export const useRouterKey = Symbol() as InjectionKey<UseRouter | UseMockedRouter>;

export type UseRoute = typeof useRoute;
export type UseMockedRoute = typeof useMockedRoute;
export const useRouteKey = Symbol() as InjectionKey<UseRoute | UseMockedRoute>;

export type UseFetch = typeof useFetch;
export const useFetchKey = Symbol() as InjectionKey<UseFetch>;

export type UseAuth = typeof useAuth;
export const useAuthKey = Symbol() as InjectionKey<UseAuth>;

export type UseFirebaseStorage = typeof useFirebaseStorage;
export type UseMockFirebaseStorage = typeof useMockFirebaseStorage;
export const useFirebaseStorageKey = Symbol() as InjectionKey<UseFirebaseStorage | UseMockFirebaseStorage>;
